exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html{background-color:#2d2d2d}#app{font-size:20px;font-weight:100;font-family:sans-serif;color:#bdbdbd}div p{margin:5px auto;font-size:2rem;text-shadow:3px 5px 3px rgba(0,0,0,.2)}.main{text-align:center}.title{margin:40px auto auto}.title>h1{display:inline;line-height:6rem;font-weight:lighter;font-size:4rem}.btn-wrap{display:flex;flex-direction:column;margin:auto;min-width:300px;max-width:80%}.button{cursor:default;min-width:10rem;padding:8px 0;margin:5px auto;border:1px solid #bdbdbd;border-radius:3px;box-shadow:.3em .5em 1em 1px rgba(0,0,0,.2)}.button.light{background-color:hsla(0,0%,100%,.1)}.sm{color:#bd2d2d;border-color:#bd2d2d}.on{color:#2dbd2d;border-color:#2dbd2d}.off{color:#e1bd41;border-color:#e1bd41}.bold{font-weight:600}.hide{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/main.scss
// module id = 217
// module chunks = 0